import { MarkdownSerializer } from 'prosemirror-markdown';

export const serializeHtmlToMarkdown = new MarkdownSerializer(
  {
    paragraph(state, node) {
      if (node.content.size === 0) {
        state.write('<p></p>');
      }
      state.renderInline(node);
      state.closeBlock(node);
    },
    text(state, node) {
      state.text(node.text ?? '');
    },
    heading(state, node) {
      state.write(`${state.repeat('#', node.attrs.level)} `);
      state.renderInline(node, false);
      state.closeBlock(node);
    },
    bulletList(state, node) {
      state.renderList(node, '  ', () => `${node.attrs.bullet || '*'} `);
    },
    listItem(state, node) {
      state.renderContent(node);
    },
    orderedList(state, node) {
      const start = node.attrs.start || 1;
      const maxW = String(start + node.childCount - 1).length;
      const space = state.repeat(' ', maxW + 2);
      const delimiter = node.attrs.parens ? ')' : '.';
      state.renderList(node, space, (item) => {
        const nStr = String(start + item);
        return `${state.repeat(' ', maxW - nStr.length) + nStr}${delimiter} `;
      });
    },
    blockquote(state, node) {
      if (node.attrs.multiline) {
        state.write('>>>');
        state.ensureNewLine();
        state.renderContent(node);
        state.ensureNewLine();
        state.write('>>>');
        state.closeBlock(node);
      } else {
        state.wrapBlock('> ', null, node, () => state.renderContent(node));
      }
    },
    image(state, node) {
      state.write(`![${state.esc(node.attrs.alt || '')}](${node.attrs.src})`);
      state.closeBlock(node);
    },
    horizontalRule(state, node) {
      state.write(node.attrs.markup || '---');
      state.closeBlock(node);
    },
    mention(state, node) {
      const variable = node.attrs.id || node.attrs.mention;
      const def = node.attrs.default;
      if (def && def.length > 0) {
        state.write(`{{${variable}|default('${def}')}}`);
      } else {
        state.write(`{{${variable}}}`);
      }
    },
  },
  {
    bold: {
      open: '**',
      close: '**',
      mixable: true,
      expelEnclosingWhitespace: true,
    },
    italic: {
      open: '*',
      close: '*',
      mixable: true,
      expelEnclosingWhitespace: true,
    },
    strike: {
      open: '~~',
      close: '~~',
      mixable: true,
      expelEnclosingWhitespace: true,
    },
    underline: {
      open: '<u>',
      close: '</u>',
      mixable: true,
      expelEnclosingWhitespace: true,
    },
    link: {
      open: '[',
      close(_state, mark) {
        return `](${mark.attrs.href})`;
      },
      mixable: true,
      expelEnclosingWhitespace: true,
    },
  },
  {
    strict: false,
  },
);
